import { message } from "antd";
import axios from "axios";
import React, { useState } from "react";
import { useNavigate } from "react-router";
import { Eye, EyeOff } from 'lucide-react';
import "./Login.css";

const ChangePassword = () => {
  const [password, setPassword] = useState("");
  const [oldPassword, setOldPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  // State for password visibility
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    try {
      setLoading(true);
      const userType = localStorage.getItem("userType");
      const user = JSON.parse(localStorage.getItem("userData"));

      if (!user?.id) {
        setError("User data not found");
        return;
      }

      await axios.post(`/changePasswordAgent/${user.id}`, {
        role: userType,
        oldPassword,
        password,
        confirmPassword,
      });

      message.success("Password changed successfully!");
      navigate("/");
    } catch (err) {
      setError(err.response?.data?.message || "An error occurred");
    } finally {
      setLoading(false);
    }
  };

  // Helper to render password input with toggle
  const renderPasswordInput = (label, value, onChange, placeholder, showState, setShowState) => (
    <div className="form-group">
      <label>{label}</label>
      <div style={{ position: 'relative' }}>
        <input
          type={showState ? "text" : "password"}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          required
          disabled={loading}
          style={{ paddingRight: '40px' }}
        />
        <button
          type="button"
          onClick={() => setShowState(!showState)}
          style={{
            position: 'absolute',
            right: '10px',
            top: '50%',
            transform: 'translateY(-50%)',
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            color: '#666',
            padding: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          {showState ? <EyeOff size={20} /> : <Eye size={20} />}
        </button>
      </div>
    </div>
  );

  return (
    <div className="login-wrapper">
      <div className="reset-container">
        <div className="login-form-wrapper">
          <h2>Change Password</h2>
          <p className="login-subtitle">Update your account password</p>

          {error && <div className="error-alert">{error}</div>}

          <form onSubmit={handleSubmit}>
            {renderPasswordInput(
              "Current Password",
              oldPassword,
              (e) => setOldPassword(e.target.value),
              "Enter current password",
              showOldPassword,
              setShowOldPassword
            )}

            {renderPasswordInput(
              "New Password",
              password,
              (e) => setPassword(e.target.value),
              "Enter new password",
              showNewPassword,
              setShowNewPassword
            )}

            {renderPasswordInput(
              "Confirm New Password",
              confirmPassword,
              (e) => setConfirmPassword(e.target.value),
              "Re-enter new password",
              showConfirmPassword,
              setShowConfirmPassword
            )}

            <button
              type="submit"
              className="login-button"
              disabled={loading}
            >
              {loading ? "Updating Password..." : "Update Password"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;